const Constant = {
  APP_NAME: process.env.REACT_APP_APP_NAME,
  MAX_SELECT_OPTION_SIZE: Number(process.env.REACT_APP_MAX_SELECT_OPTION_SIZE),
  statusSuccess: process.env.REACT_APP_STATUS_SUCCESS,
  statusFailure: process.env.REACT_APP_STATUS_FAILURE,
  perPage: Number(process.env.REACT_APP_PER_PAGE),
  successCode: Number(process.env.REACT_APP_SUCCESS_CODE),
  updateSuccessCode: Number(process.env.REACT_APP_UPDATE_SUCCESS_CODE),
  apiBasePath: process.env.REACT_APP_API_BASE_PATH,
  socketPath: process.env.REACT_APP_SOCKET_PATH,
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
};

export default Constant;